import React, { useEffect } from 'react';
import './NotificationCard.css';

function NotificationCard({ mensagem, onClose, onResponder }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 8000);
        return () => clearTimeout(timer);
    }, [mensagem, onClose]);

    const getFotoUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http')) return url;
        const apiUrl = import.meta.env.VITE_API_URL || 'https://api.agroov.com';
        return `${apiUrl.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
    }

    return (
        <div className="notification-card">
            <div className="notification-header">
                <span className="notification-tag">💬 Nova Mensagem</span>
                <button className="close-btn" onClick={onClose}>✕</button>
            </div>
            <div className="notification-body">
                <div className="notification-avatar">
                    {mensagem.remetente_foto ? (
                        <img src={getFotoUrl(mensagem.remetente_foto)} alt={mensagem.remetente_nome} />
                    ) : (
                        <div className="avatar-placeholder">
                            {mensagem.remetente_nome?.charAt(0)}
                        </div>
                    )}
                </div>
                <div className="notification-content">
                    <h4>{mensagem.remetente_nome}</h4>
                    <p>{mensagem.conteudo}</p>
                </div>
            </div>
            <div className="notification-footer">
                <button className="btn-action" onClick={() => { onResponder(); onClose(); }}>
                    Responder
                </button>
            </div>
        </div>
    );
}

export default NotificationCard;
